
import styled from 'styled-components';
import "../../assets/style/style.css"

import { PuffLoader } from "react-spinners"
import { lightThemeColors } from '../../assets/style/colors';
function SpinnerComponent({ children }) {
    return (
        <Wrapper>
            <PuffLoader color={lightThemeColors.darkColor} />
        </Wrapper>
    );
}

export default SpinnerComponent;

const Wrapper = styled.div`
postition:absolute;
top:0;
right:0;
left:0;
bottom:0;
width:100%;
display:flex;
align-items:center;
justify-content:center;
z-index:9999;
`